import CustomText from "./Text";

import "../styles/App.css"

type HeaderProps = {
  addBreak?: boolean;
  content: string;
};

const Header: React.FC<HeaderProps> = ({ addBreak = true, content }) => {
  return (
    <>
      <img alt='header' src={`/images/logo.png`} className="headerLogo" />
      <CustomText type="title" content={content} />
      {addBreak && <br/>}
    </>
  );
};

export default Header;
